<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center">
        <dara-header>
          {{ $t('articles') }}
          <el-tooltip effect="dark" :content="$t('some-articles-may-not-appear-due-to-permission')" placement="right-end">
            <dara-icon size="lg" icon="info-circle-fill" class="ms-1" />
          </el-tooltip>
        </dara-header>
        <dara-button v-if="user.permission > USERS_ROLES.READER" @click="onCreateArticle">
          {{ $t('write-article') }}
        </dara-button>
      </div>
      <!-- <dara-small
        class="color--danger">
        * {{ $t('some-articles-may-not-appear-due-to-permission') }}
      </dara-small> -->
      <table v-if="articleList && articleList.length > 0" class="table el-table my--lg">
        <tbody>
          <tr v-for="article in articleList" :key="article.id">
            <td class="align-middle" style="width: 10%">
              <dara-image
                fit="cover"
                :height="85"
                :width="125"
                :src="getArticleImageSrc(article)" />
            </td>
            <td class="py--lg px--md">
              <dara-header v-truncate size="sm">
                <dara-article-link :id="article.id" :slug="article.slug">
                  {{ article.title }}
                </dara-article-link>
              </dara-header>
              <dara-p v-truncate size="md" margin="md">{{ article.resume }}</dara-p>
              <dara-small>{{ getUpdatedAt(article) }}</dara-small>
            </td>
            <td class="align-middle text-end">
              <el-dropdown v-if="canEdit(article)" trigger="click">
                <dara-icon
                  icon="three-dots-vertical"
                  class="cursor--pointer mx--md" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <dara-article-link
                      :id="article.id"
                      action="edit">
                      <dara-icon size="sm" icon="pencil" />
                      {{ $t('edit') }}
                    </dara-article-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <a @click="setDeleteArticle(article)">
                      <dara-icon size="sm" icon="trash" />
                      {{ $t('delete') }}
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <dara-modal-delete
                v-if="showModal(article)"
                :content="$t('are-you-sure-you-want-to-delete-this-article')"
                @close="setDeleteArticle(null)"
                @confirm="onDeleteArticle(article)">
              </dara-modal-delete>
            </td>
          </tr>
        </tbody>
      </table>
      <dara-p v-else class="opacity--50 my--lg">( {{ $t('no-articles') }} )</dara-p>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetchArticles" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { formatToTimeAgo } from '@/helpers/date';
import { goToCreateArticle } from '@/modules/article/article.routes';
import { fetchArticles, getArticleImageCover, removeArticle } from '@/modules/article/article.service';
import { translate } from '@/services/translate.service';
import { getters } from '@/modules/user/user.store';
import { USERS_ROLES } from '@/modules/user/user.constants';

import DaraArticleLink from '@/modules/article/components/ArticleLink.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceArticles',
  components: {
    DaraArticleLink,
    DaraSingleContentLayout,
  },
  data() {
    return {
      user: getters.getUser(),
      articleList: null,
      articleDelete: null,
      pagination: {
        page: 1,
        limit: 5,
      },
      USERS_ROLES,
    };
  },
  computed: {
  },
  mounted() {
    this.fetchArticles();
  },
  methods: {
    fetchArticles() {
      this.articleList = [];
      fetchArticles(this.pagination)
        .then(data => {
          this.articleList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.articleList = null;
        });
    },
    getArticleImageSrc(article) {
      return getArticleImageCover(article);
    },
    getUpdatedAt(article) {
      return `${translate('last-update')} ${formatToTimeAgo(article.updated_at)}`;
    },
    setDeleteArticle(article) {
      this.articleDelete = article;
    },
    canEdit(article) {
      return (this.user.permission > 0 && (this.user.permission > 1 || (article.user_id === this.user.id)));
    },
    showModal(article) {
      return this.articleDelete && this.articleDelete.id === article.id;
    },
    onDeleteArticle(article) {
      removeArticle(article).then(() => this.$router.go(0));
    },
    onCreateArticle() {
      goToCreateArticle(this.$router);
    },
  },
};
</script>
